import type { GdsPlanningOccurrence } from '~/models'
import { ArrayService } from '../serviceLive'
import { query, where } from 'firebase/firestore'

export class GdsPlanningOccurrenceService extends ArrayService<GdsPlanningOccurrence> {
  constructor() {
    super('GdsPlanningOccurrence')
  }

  public listenForGdsPlanningIds(gdsPlanningIds: string[]): void {
    const queries = gdsPlanningIds.map(id =>
      query(this.collection, where('GdsPlanningId', '==', id)),
    )

    this.listenGroup(queries)
  }
}
